export default __webpack_public_path__ + "static/media/RivaMobileLogo.34dde9b3.svg";